{ "columns":0,
 "grid":
    {
     "height":1,
     "orientation":"orthogonal",
     "width":1
    },
 "margin":0,
 "name":"tileset",
 "spacing":0,
 "tilecount":18,
 "tiledversion":"1.8.6",
 "tileheight":32,
 "tiles":[
        {
         "id":0,
         "image":"tiles\/2.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":1,
         "image":"tiles\/1.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":2,
         "image":"tiles\/3.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":3,
         "image":"tiles\/4.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":4,
         "image":"tiles\/5.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":5,
         "image":"tiles\/7.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":6,
         "image":"tiles\/8.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":7,
         "image":"tiles\/9.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":8,
         "image":"tiles\/railing.png",
         "imageheight":32,
         "imagewidth":32,
         "properties":[
                {
                 "name":"shape",
                 "type":"string",
                 "value":"south-edge"
                }]
        }, 
        {
         "id":9,
         "image":"tiles\/ledge.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":11,
         "image":"tiles\/ledge2.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":12,
         "image":"tiles\/water.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":13,
         "image":"tiles\/water2.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":14,
         "image":"tiles\/10.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":15,
         "image":"tiles\/11.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":16,
         "image":"tiles\/12.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":17,
         "image":"tiles\/13.png",
         "imageheight":32,
         "imagewidth":32
        }, 
        {
         "id":18,
         "image":"tiles\/14.png",
         "imageheight":32,
         "imagewidth":32
        }],
 "tilewidth":32,
 "type":"tileset",
 "version":"1.8"
}